import { GetterTree } from 'vuex'
import { ApiState } from './types'
import { RootState } from '../types'

export const getters: GetterTree<ApiState, RootState> = {
  isLogged: (state: ApiState) => state.accessToken !== null,
  getShouldAccept: (state: ApiState) => state.shouldAccept,
  getError: (state: ApiState) => (name: string) => state.errors[name]
}
